import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://glhqscvumontbkmcqyvh.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdsaHFzY3Z1bW9udGJrbWNxeXZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY5OTEwNjYsImV4cCI6MjA5MjU2NzA2Nn0.mjrljn40iMxljyKoC5wofQ4hvn3y3GQSUmgVz1nh7fA'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
